import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { IShipmentPriceItemData, IServiceDetails } from '../../models/shipment-price.interface';
import { ShipmentPriceService } from '../shipment-price.service';

@Injectable()
export class ShipmentPriceItemResolverService implements Resolve<IShipmentPriceItemData> {
    constructor(
        private shipmentPriceSvc: ShipmentPriceService,
    ) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IShipmentPriceItemData> {
        const {id} = route.params;
        return this.shipmentPriceSvc.getPriceItemDetailsById(id);
    }
}
